import webuiState from "../app/InternalStateService";

//GET UI config of a mixin
export const MIXIN_REQUEST = "MIXIN_REQUEST";
export const SAVE_MIXIN_TO_CACHE = "SAVE_MIXIN_TO_CACHE";

// let requests = {
//     mixinId1: Promise,
//     mixinId2: Promise,
//     ...
//     mixinIdn: Promise
// };
let requests = {};

function requestMixinData(id, url, widgetId) {
    let { MIXIN_ROOT } = webuiState.getWebConfig();
    // there should be no mixins with same id and different url
    let endpoint = url ? url : `${MIXIN_ROOT}/${id}`;
    return async (dispatch) => {
        let request = requests[id];
        if (!request) {
            // request
            dispatch({
                type: MIXIN_REQUEST
            });

            let options = {
                method: "GET",
                endpoint: endpoint
            };
            //in case of predefined configuration location within the application
            //override
            let { STATIC_CONFIGURATIONS_ROOT } = webuiState.getWebConfig();
            if (STATIC_CONFIGURATIONS_ROOT) {
                options.endpoint = STATIC_CONFIGURATIONS_ROOT + endpoint.split("?")[0] + ".json";
                options.rawEndpointUrl = true;
            }
            const urlParser = webuiState.getStaticConfigUrlParser({ widgetId });
            if (urlParser) {
                options.endpoint = await urlParser({
                    context: "mixin",
                    endpoint: endpoint,
                    id: id
                });
                options.rawEndpointUrl = true;
            }
            //check whether the application is responsible for loading static configuration
            let staticConfigLoader = webuiState.getStaticConfigLoader({ widgetId });
            let lazyModuleLoader = webuiState.getLazyModuleLoader({ widgetId });
            if (staticConfigLoader) {
                request = staticConfigLoader.load({
                    id,
                    type: "mixin",
                    defaultRequestOptions: options
                });
            } else if (lazyModuleLoader) {
                let module = lazyModuleLoader.load({
                    id,
                    type: "mixin"
                });
                request = module.config;
            } else {
                //default behaviour is to make a request for UI configuration
                request = dispatch(webuiState.getActionByName("request.request")(options));
            }

            // store promise
            requests[id] = request;
        }
        return request;
    };
}

function getMixinFromCache(mixinId) {
    return (dispatch, getState) => {
        let result = getState().getIn(["global", "mixin-cache", mixinId]);
        if (result) {
            return result.toJS();
        }
    };
}

//fetches a mixin item
//"config" object is updated with the result
//mixinQueue is updated also
export async function fetchMixinItem(config = {}, mixinQueue = [], widgetId) {
    const dispatch = webuiState.getDispatchMethod();
    let id = config.id;
    let url = config.url;
    delete config.type;
    delete config.id;
    delete config.url;
    delete config.beforeWidgetRender;
    // cache
    let actionResult = await dispatch(getMixinFromCache(id));
    if (!actionResult) {
        //checking if already requested before making a request (could be requested but not yet in cache)
        let alreadyRequested = !!requests[id];
        // get promise or make new request
        actionResult = await dispatch(requestMixinData(id, url, widgetId));
        // additional check: dispatch only once per mixin
        if (!alreadyRequested) {
            // store in cache
            await dispatch({
                type: SAVE_MIXIN_TO_CACHE,
                mixinId: id,
                payload: Object.assign({}, actionResult)
            });
        }
    }
    //updating mixinQueue to avoid cycles of mixin configuration
    mixinQueue.push(id);
    Object.keys(actionResult).forEach((key) => {
        if (!config.hasOwnProperty(key)) {
            config[key] = actionResult[key];
        }
    });
}
